import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

import { ApiService } from '../api/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetTermsResponse, TermType } from '../models/terms.model';

@Injectable({
  providedIn: 'root',
})
export class TermsResolver {
  constructor(private api: ApiService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<GetTermsResponse> {
    return this.api.getTerms(TermType.general);
  }
}

export const termsResolver: ResolveFn<boolean> = (route, state) => {
  return true;
};
